module.exports = __webpack_public_path__ + "img/L2.ed70b8b3.jpg";